import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { THEME_VARIANT } from '@shared/constants';
import {
  AppContextProvider,
  AppContextConsumer,
  AuthContextProvider,
  UserContextProvider,
  LoaderContextProvider,
} from '@shared/contexts';
import { Loader } from '@shared/components';
import Modules from './modules';
import * as serviceWorker from './serviceWorker';
import '@assets/fonts/fontface.css';
import 'react-datepicker/dist/react-datepicker.css';

// if (process.env.NODE_ENV === 'development') {
//   const whyDidYouRender = require('@welldone-software/why-did-you-render');
//   whyDidYouRender(React, {
//     logOnDifferentValues: true,
//     trackAllPureComponents: true,
//     collapseGroups: true,
//   });
// }
const App = () => {
  return (
    <React.StrictMode>
      <AppContextProvider>
        <AuthContextProvider>
          <UserContextProvider>
            <AppContextConsumer>
              {({ selectedThemeVariant, selectedTheme }) => (
                <ThemeProvider
                  theme={
                    selectedThemeVariant === THEME_VARIANT.LIGHT
                      ? { ...selectedTheme.Light }
                      : { ...selectedTheme.Dark }
                  }
                >
                  {/* <LoaderContextProvider> */}
                  {/* <Loader /> */}
                  <Modules />
                  {/* </LoaderContextProvider> */}
                </ThemeProvider>
              )}
            </AppContextConsumer>
          </UserContextProvider>
        </AuthContextProvider>
      </AppContextProvider>
    </React.StrictMode>
  );
};
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
